// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { EmailMessage } from "../../../data/messaging/email-message";
import { EmailMessageRecipient } from "../../../data/messaging/email-message-recipient";
import { EmailMessageAttachment } from "../../../data/messaging/email-message-attachment";
import { EnvelopeDocument } from "../base/envelope-document";

export class EmailMessageDocument extends EnvelopeDocument {
	public override Item: EmailMessage = new EmailMessage();
	public Recipients: EmailMessageRecipient[] = [];
	public Attachments: EmailMessageAttachment[] = [];
}